import { useState } from "react";
import { toast } from "sonner";
import { NotebookPen } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiError } from "@/lib/api";

export default function ProcessesBox({ c, readOnly }) {
  const [text, setText] = useState(c.processes || "");
  const [saved, setSaved] = useState(c.processes || "");
  const save = async () => {
    try {
      await api.put(`/jobs/${c.job_id}/processes`, { processes: text });
      setSaved(text);
      toast.success("Processes saved. They'll show on this client's job card every period.");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <div className="rounded-xl border border-[#0090D0]/30 bg-[#0090D0]/[0.05] p-3" data-testid={`card-processes-${c.id}`}>
      <div className="flex items-center justify-between mb-1.5">
        <p className="text-[10px] uppercase tracking-[0.15em] text-[#0090D0] font-semibold inline-flex items-center gap-1"><NotebookPen size={11} /> Processes</p>
        {!readOnly && text !== saved && (
          <button onClick={save} data-testid={`card-processes-save-${c.id}`}
            className="rounded-full bg-[#103080] text-white text-[11px] font-semibold px-3 py-1 hover:bg-[#0090D0] transition-colors duration-200">Save</button>
        )}
      </div>
      <Textarea value={text} readOnly={readOnly} onChange={(e) => setText(e.target.value)} rows={Math.min(10, Math.max(4, text.split("\n").length))}
        placeholder="How we do this client's job each time, e.g. where records come from, quirks to remember"
        className="rounded-lg bg-white border-[#103080]/15 text-xs" data-testid={`card-processes-input-${c.id}`} />
      <p className="text-[10px] text-[#0F172A]/40 mt-1">Carries over to every future job card for this client and service. Work notes only.</p>
    </div>
  );
}
